// src/AuthAction.js — E-Mail-Verifizierung & Passwort-Reset (Link aus E-Mail)
import React, { useEffect, useState } from 'react';

const S = {
  page:  { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', background: 'var(--bg)' },
  card:  { background: '#0d1520', border: '1px solid rgba(0,212,255,0.2)', borderRadius: '16px', padding: '2.5rem 2rem', maxWidth: '420px', width: '100%', textAlign: 'center' },
  icon:  { fontSize: '2.5rem', marginBottom: '1rem' },
  title: { fontFamily: 'var(--font-head)', fontSize: '1.4rem', fontWeight: 900, color: '#fff', marginBottom: '0.6rem' },
  sub:   { fontSize: '0.85rem', color: 'var(--muted)', marginBottom: '1.5rem', lineHeight: 1.6 },
  label: { display: 'block', fontSize: '0.72rem', fontWeight: 700, color: 'var(--muted)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.5rem', textAlign: 'left' },
  input: { display: 'block', width: '100%', padding: '0.75rem 1rem', background: 'rgba(255,255,255,0.05)', border: '1px solid var(--border)', borderRadius: '8px', color: '#fff', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', marginBottom: '0.85rem' },
  btn:   { width: '100%', padding: '0.85rem', background: 'var(--cyan)', border: 'none', borderRadius: '8px', color: '#0a0a0a', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer', fontFamily: 'var(--font-head)', letterSpacing: '0.03em', marginBottom: '0.75rem', transition: 'opacity 0.2s' },
  err:   { background: 'rgba(255,80,80,0.08)', border: '1px solid rgba(255,80,80,0.25)', borderRadius: '6px', padding: '0.6rem 0.9rem', marginBottom: '0.75rem', fontSize: '0.82rem', color: '#ff8888' },
  success: { background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.25)', borderRadius: '6px', padding: '0.6rem 0.9rem', marginBottom: '0.75rem', fontSize: '0.82rem', color: '#4ade80' },
  link:  { color: 'var(--cyan)', fontSize: '0.85rem', textDecoration: 'underline' },
};

export default function AuthAction() {
  const params = new URLSearchParams(window.location.search);
  const mode = params.get('mode');
  const token = params.get('token');

  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [message, setMessage] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');

  useEffect(() => {
    if (mode === 'verify-email' && token) {
      setStatus('loading');
      fetch('/api/auth/verify-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      })
        .then(r => r.json().then(d => ({ ok: r.ok, d })))
        .then(({ ok, d }) => {
          setStatus(ok && d.success ? 'success' : 'error');
          setMessage(d.message || d.error || 'Unbekannter Fehler.');
        })
        .catch(() => {
          setStatus('error');
          setMessage('Netzwerkfehler. Bitte versuche es erneut.');
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitReset = async () => {
    setMessage('');
    if (password.length < 8) return setMessage('Das Passwort muss mindestens 8 Zeichen lang sein.');
    if (password !== password2) return setMessage('Die Passwörter stimmen nicht überein.');

    setStatus('loading');
    try {
      const r = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const d = await r.json();
      setStatus(r.ok && d.success ? 'success' : 'error');
      setMessage(d.message || d.error || 'Unbekannter Fehler.');
    } catch {
      setStatus('error');
      setMessage('Netzwerkfehler. Bitte versuche es erneut.');
    }
  };

  if (!token || (mode !== 'verify-email' && mode !== 'reset-password')) {
    return (
      <div style={S.page}>
        <div style={S.card}>
          <div style={S.icon}>⚠️</div>
          <h1 style={S.title}>Ungültiger Link</h1>
          <p style={S.sub}>Dieser Link ist unvollständig oder ungültig.</p>
          <a href="/" style={S.link}>Zur Startseite</a>
        </div>
      </div>
    );
  }

  if (mode === 'verify-email') {
    return (
      <div style={S.page}>
        <div style={S.card}>
          <div style={S.icon}>{status === 'success' ? '✅' : status === 'error' ? '⚠️' : '✉️'}</div>
          <h1 style={S.title}>E-Mail-Bestätigung</h1>
          {status === 'loading' && <p style={S.sub}>Wird geprüft…</p>}
          {status === 'success' && <div style={S.success}>{message}</div>}
          {status === 'error' && <div style={S.err}>{message}</div>}
          {status !== 'loading' && <a href="/" style={S.link}>Zur Anmeldung</a>}
        </div>
      </div>
    );
  }

  // mode === 'reset-password'
  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.icon}>🔑</div>
        <h1 style={S.title}>Neues Passwort vergeben</h1>

        {status === 'success' ? (
          <>
            <div style={S.success}>{message}</div>
            <a href="/" style={S.link}>Zur Anmeldung</a>
          </>
        ) : (
          <>
            <p style={S.sub}>Gib dein neues Passwort ein (mind. 8 Zeichen).</p>
            {message && <div style={S.err}>{message}</div>}

            <label style={S.label} htmlFor="reset-password">Neues Passwort</label>
            <input id="reset-password" style={S.input} type="password" autoComplete="new-password"
              value={password} onChange={e => setPassword(e.target.value)} disabled={status === 'loading'} />

            <label style={S.label} htmlFor="reset-password2">Passwort wiederholen</label>
            <input id="reset-password2" style={S.input} type="password" autoComplete="new-password"
              value={password2} onChange={e => setPassword2(e.target.value)} disabled={status === 'loading'}
              onKeyDown={e => { if (e.key === 'Enter') submitReset(); }} />

            <button style={{ ...S.btn, opacity: status === 'loading' ? 0.6 : 1 }} onClick={submitReset} disabled={status === 'loading'}>
              {status === 'loading' ? 'Wird gespeichert…' : 'Passwort speichern'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
